import { Typography } from '@mui/material'
import React from 'react'
import { DateInput, StyledButton, TextFields } from '../../../../../../components'
import classes from './form.module.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { usePostApi } from '../../../../../../shared'
import { urls } from '../../../../../../shared/config'
import { setLoader, setRefreshPage } from '../../../../../../redux/globalSlice'
import { useDispatch } from 'react-redux'

const HolidayForm = ({ setsuccess, handleClose, customRole, userSchoolId }) => {
  const dispatch = useDispatch()
  const [step, setStep] = React.useState(1)
  const { postApi } = usePostApi()
  const initialValues = {
    name: '',
    date: '',
  }

  const validationSchema = Yup.object({
    name: Yup.string().required('Holiday Name is required'),
    date: Yup.string().required('Date is Required'),
  })

  const handleSubmit = () => {
    dispatch(setLoader(true))
    validationSchema
      .validate(formik.values, { abortEarly: false })
      .then(async () => {
        if (customRole != 'Admin') {
          if (!formik.values.name) {
            toast.error('School is required')
            dispatch(setLoader(false))
            return
          }
        }
        const studentData = {
          school_id: userSchoolId,
          name: formik.values.name,
          ...(formik.values.date ? { date: formik.values.date } : {}),
        }
        postApi(urls.HOLIDAY_POST, studentData)
          .then((response) => {
            if (response.status == 201 || response.status == 200) {
              // const { student_id, student_avatar, student_grade, student_section } = response.data
              // setStudentId(student_id)
              // setImage(student_avatar)
              // setSGrade(student_grade)
              // setSection(student_section)
              toast.success('Holiday Added Successfully!')
              handleNext()
              dispatch(setRefreshPage(true))
              setsuccess(true)
              dispatch(setLoader(false))
            } else {
              if (response.message) {
                toast.error(response.message)
              } else {
                toast.error(response.error.message)
              }
              dispatch(setLoader(false))
            }
          })
          .catch((error) => {
            console.error('Error in catch:', error)
            toast.error('Something Went Wrong!', error)
            dispatch(setLoader(false))
          })
      })
      .catch((errors) => {
        console.log('Error:', errors)
        errors?.inner?.forEach((error) => {
          toast.error(error.message)
        })
        dispatch(setLoader(false))
      })
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  })

  const handleNext = () => {
    setStep((prevStep) => prevStep + 1)
  }

  // const StudentSucess = ({ handleClose }) => {
  //   const [download, setDownload] = useState(false)
  //   const handleOpen = () => {
  //     setDownload(true)
  //   }
  //   return (
  //     <div style={{ width: '100%' }}>
  //       <div
  //         className="school-info"
  //         style={{ paddingBottom: '10px', justifyContent: 'space-between' }}
  //       >
  //         <Typography>Registration Number</Typography>
  //         <Typography>{formik.values.studentRollNo}</Typography>
  //       </div>
  //       <Divider />
  //       <div className="school-info" style={{ marginTop: '10px' }}>
  //         {image ? (
  //           <Avatar
  //             alt={''}
  //             src={image || formik.values.holiday_name}
  //             sx={{ width: '36px', height: '36px' }}
  //           />
  //         ) : (
  //           <Avatar
  //             alt={''}
  //             sx={{ width: '36px', height: '36px', backgroundColor: '#F2ECF9', color: '#492972' }}
  //           >
  //             {formik.values.holiday_name.charAt(0).toUpperCase()}
  //           </Avatar>
  //         )}
  //         <div>
  //           <Typography fontWeight={600}>{formik.values.holiday_name}</Typography>
  //           <Typography sx={{ color: '#98A1B2', fontSize: '12px' }}>
  //             Class: {sGrade}-{Section}
  //           </Typography>
  //         </div>
  //       </div>
  //       <div style={{ marginTop: '20px', display: 'grid', placeItems: 'center' }}>
  //         <CloseCommonSuccess hnhleOpen={handleOpen} handleClose={handleClose} />
  //       </div>
  //       {download && (
  //         <QRCodeDisplay
  //           name={formik.values.holiday_name}
  //           open={download}
  //           handleClose={() => setDownload(false)}
  //           value={studentID}
  //         />
  //       )}
  //     </div>
  //   )
  // }

  // if (success) {
  //   return (
  //     <SuccessBox
  //       student
  //       close={() => {
  //         setsuccess(false)
  //         handleClose()
  //       }}
  //     >
  //       <StudentSucess handleClose={handleClose} />
  //     </SuccessBox>
  //   )
  // }
  return (
    <div className="add-employee">
      {step == 1 && (
        <Step1 formik={formik} onCancel={() => handleClose()} onSubmit={handleSubmit} />
      )}
      {/* {step == 2 && <Step2 formik={formik} onNext={onStep2} onPrev={handlePrev} />} */}
      {step == 2 && <Step3 formik={formik} handleClose={() => handleClose()} />}
    </div>
  )
}

export default HolidayForm

const Step1 = ({ formik, onCancel, onSubmit }) => {
  return (
    <div>
      <div className="text-fields">
        <TextFields
          required
          label={'Name of the Holiday'}
          placeholder={'Holiday Name'}
          name={'name'}
          value={formik.values.name}
          onChange={formik.handleChange}
        />
      </div>

      <DateInput
        required
        label={'Date'}
        value={formik.values.date}
        name={'date'}
        onChange={formik.handleChange}
      />

      <div className="in-a-row" style={{ justifyContent: 'flex-end' }}>
        <Typography className="back-btn" onClick={onCancel}>
          Back
        </Typography>

        <StyledButton width={'40%'} onClick={onSubmit}>
          Add
        </StyledButton>
      </div>
    </div>
  )
}

const Step3 = ({ handleClose }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '42px',
        width: '250px',
        outline: 'none',
      }}
    >
      <p className={classes.txt}>Done!</p>
      <button onClick={handleClose} className={classes.donebtn}>
        Okay
      </button>
    </div>
  )
}
